import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    background: '#000000',
    text: '#FFFFFF',
    primary: '#FDBA31',
    secondary: '#282c34',
  },
  fontSizes: {
    small: '14px',
    medium: '16px',
    large: '18px',
  },
  spacing: {
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
};

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
  }
`;